import React, {useContext} from 'react';
import {SharedMap} from "@fluidframework/map/legacy";
import {defaultSharedObjectMutators, SharedObjectMutators} from "./SharedObjectMutators";
import {NO_OP} from "../../../../constants/common";

export type MeetingContainerSchema = {
    meetingControlDDS: SharedMap;
    domContentDDS: SharedMap;
    canvasContentDDS: SharedMap;
    meetingPortalParticipantJoinDDS: SharedMap;
    removeParticipantDDS: SharedMap;
    meetingParticipantDDS: SharedMap;
    pointerCoordinatesInfoDDS: SharedMap;
};

type RelayContextValue = {
    containerId: string;
    createMeetingContainer: (userId: string, userName: string) => Promise<{ containerId: string, documentId: string }>;
    connectToMeetingContainer: (userId: string, userName: string, containerId: string) => Promise<void>;
    connectToMeetingContainerFromMeetingPortal: (
        containerId: string,
        fluidToken: string,
        joinMeetingId: string,
        joinMeetingPasscode: string,
        user: {
            id: string,
            name: string,
        },
        communicationsIdentifier: string | null,
    ) => Promise<void>;
    unloadMeetingContainer: () => void;
    disconnectFromMeetingContainer: () => void;
    cleanUpSharedObjects: () => void;
    sharedObjectMutators: SharedObjectMutators;
    sharedObjects: MeetingContainerSchema | null;
}

const defaultValue: RelayContextValue = {
    containerId: '',
    createMeetingContainer: () => Promise.resolve({containerId: '', documentId: ''}),
    connectToMeetingContainer: () => Promise.resolve(),
    connectToMeetingContainerFromMeetingPortal: () => Promise.resolve(),
    unloadMeetingContainer: NO_OP,
    disconnectFromMeetingContainer: NO_OP,
    cleanUpSharedObjects: NO_OP,
    sharedObjectMutators: defaultSharedObjectMutators,
    sharedObjects: null,
};

const relayContext = React.createContext(defaultValue);

export const useRelayContext = () => {
    return useContext(relayContext);
};

export default relayContext;